// *For improving the app
// *https://github.com/welldone-software/why-did-you-render
// *import './wdyr'; // <--- first import

import React, { Component } from "react";
import { Route, Redirect } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";

import Layout from "./Layout";
import Login from "./Login";
import auth from "./Auth";

import StartPage from "./startPage/StartPage";
import FaqPage from "./faqPage/FaqPage";
import Home from "./home/Home";
import SubmissionSelection from "./SubmissionSelection";

import { SubmitDataset } from "./views/submission/submit-datasets/SubmitDataset";

// import SubmitDatasetFunctional  from "./views/submission/submit-datasets/SubmitDatasetFunctional";
import { SubmitFiles } from "./views/submission/submit-files/SubmitFiles";
import { SubmitProjects } from "./views/submission/submit-projects/SubmitProjects";
import { SummaryInserted } from "./views/submission/submit-datasets/summary-inserted/SummaryInserted";
import SelectProject from "./views/submission/submit-datasets/SelectProject";
import { DatasetsView } from "./views/management/datasets-view/DatasetsView";
import { FilesView } from "./views/management/files-view/FilesView";

// admin views
import AdminView from "./views/management/admin-view/AdminView";
import { AdminDataView } from "./views/management/admin-view/AdminDataView";

import { ProjectsView } from "./views/management/projects-view/ProjectsView";
// import { AdminDatasetsView } from "./views/management/datasets-view/AdminDatasetsView";
// import { AdminFilesView } from "./views/management/files-view/AdminFilesView";

// import FilesViewFunctional from "./views/management/files-view/FilesViewFunctional";

import "@trendmicro/react-sidenav/dist/react-sidenav.css";

// OVERRIDE SIDENAV ELEMENTS
import "./sidenav-app/sidenav_custom.css";

// IMPORT LOGOS
import SideNavApp from "./sidenav-app/SideNav";

// The Main component renders one of the provided
// Routes (provided that one matches).

function ErrorFallback({ error, resetErrorBoundary }) {
  if (process.env.NODE_ENV !== "production") {
    return (
      <div role="alert" class="center">
        <p>Something went wrong:</p>
        <pre>{error.message}</pre>
        <button onClick={resetErrorBoundary}>Try again</button>
      </div>
    );
  }
  return <Redirect to="/home" />;
}

function AuthenticatedRoute({ component: Component, enabled, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) =>
        auth.user.authenticated === true || !enabled ? (
          <Component {...props} {...rest} />
        ) : (
          <Redirect
            to={{
              pathname: "/login/",
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
}

function renderRoutes() {
  // create routes
  return my_routes.map((route_item) => (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onReset={() => {
        // reset the state of your app so the error doesn't happen again
      }}
    >
      <AuthenticatedRoute
        path={route_item.path}
        component={route_item.component}
        enabled={route_item.security}
      />
    </ErrorBoundary>
  ));
}

const my_routes = [
  {
    path: "/home",
    component: Home,
    security: window.config.security,
  },
  {
    // TODO
    // going to that path without the automatic redirect
    // by the file submission page should be forbidden
    // and redirect to the main page
    path: "/filesubmitted",
    component: SummaryInserted,
    security: window.config.security,
  },
  {
    path: "/datasetsubmitted",
    component: SummaryInserted,
    security: window.config.security,
  },
  {
    path: "/projectsubmitted",
    component: SummaryInserted,
    security: window.config.security,
  },
  {
    path: "/submitprojects",
    component: SubmitProjects,
    security: window.config.security,
  },
  {
    path: "/createdatasets/selectproject",
    component: SelectProject,
    security: window.config.security,
  },
  {
    path: "/uploadfiles/selectproject",
    component: SelectProject,
    security: window.config.security,
  },
  {
    path: "/submitfiles",
    component: SubmitFiles,
    security: window.config.security,
  },
  {
    path: "/submitdatasets",
    component: SubmitDataset,
    security: window.config.security,
  },
  // {
  //   path: "/submitdatasets",
  //   component: SubmitDatasetFunctional,
  //   security: window.config.security,
  // },
  { path: "/files", component: FilesView, security: window.config.security },
  {
    path: "/datasets",
    component: DatasetsView,
    security: window.config.security,
  },
  {
    path: "/submission",
    component: SubmissionSelection,
    security: window.config.security,
  },
  {
    path: "/administrate",
    component: AdminView,
    security: window.config.security,
  },
  {
    path: "/admin/projects",
    component: AdminDataView,
    // component: ProjectsView,
    security: window.config.security,
  },
  {
    path: "/admin/files",
    component: AdminDataView,
    security: window.config.security,
  },
  {
    path: "/admin/datasets",
    component: AdminDataView,
    security: window.config.security,
  },
];

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      keycloak: auth.user.keycloak,
      authenticated: auth.user.authenticated,
      auth: props.auth,
    };
  }

  render() {
    return (
      <>
        <SideNavApp />
        <div className={"main"}>
          <Layout />
          <div className="content">
            <Route exact path="/" component={StartPage} />
            <Route exact path="/faq" component={FaqPage} />
            <Route path="/login" component={Login} />
            {renderRoutes()}
          </div>
        </div>
      </>
    );
  }
}

export default App;
